import { useRecoilValue, useResetRecoilState, useSetRecoilState } from 'recoil';
import { getConvoys } from '../../services/convoyService';
import {
  convoysPageState,
  convoysState,
  editingConvoyState,
  loadingConvoysState,
  searchConvoyState,
  selectedConvoyIdState,
  updateConvoysState,
} from '../../storage/convoys';
import { Convoy } from '../../types/convoy';
import { PaginatedProvider } from './PaginatedProvider';

export function ConvoysProvider() {
  const updateConvoys = useRecoilValue(updateConvoysState);
  const resetUpdateConvoys = useResetRecoilState(updateConvoysState);
  const resetEditingConvoy = useResetRecoilState(editingConvoyState);
  const setPaginatedConvoys = useSetRecoilState(convoysState);
  const setLoadingConvoys = useSetRecoilState(loadingConvoysState);
  const resetSelectedConvoyId = useResetRecoilState(selectedConvoyIdState);

  return (
    <PaginatedProvider<Convoy>
      searchState={searchConvoyState}
      pageState={convoysPageState}
      getPaginated={getConvoys}
      setPaginated={setPaginatedConvoys}
      onSearchChange={resetSelectedConvoyId}
      onUpdateFinish={() => {
        resetUpdateConvoys();
        resetEditingConvoy();
      }}
      setLoading={setLoadingConvoys}
      update={updateConvoys}
    />
  );
}
